import * as React from 'react';
import { IconSizes, CheckCircleIcon } from '@newcore/icons';
import { Button } from '@newcore/ui/buttons';
import { Text } from '@newcore/ui/typography';
import { ROUTES } from '@/common/auth-routes';
import { OnboardingStatusCard } from './onboarding-status-card';

interface OnboardingPageAlreadyCompletedProps {
  signInUrl?: string;
  userEmail?: string;
}

export function OnboardingPageAlreadyCompleted({
  signInUrl = ROUTES.TENANT_SELECTION,
  userEmail,
}: OnboardingPageAlreadyCompletedProps): React.ReactElement {
  return (
    <OnboardingStatusCard
      title="You're Already Set Up!"
      description='Good news — your NewCore account is already active. You can sign in to access your apps.'
    >
      <CheckCircleIcon
        size={IconSizes.XL}
        className='size-16 text-success-primary'
      />
      <Button asChild>
        <a href={signInUrl} data-testid='onboarding-already-completed-sign-in'>
          Sign In to NewCore
        </a>
      </Button>
      {userEmail && (
        <Text as='p' className='text-tertiary text-center'>
          Not {userEmail}? Contact IT if you need a different account.
        </Text>
      )}
    </OnboardingStatusCard>
  );
}
